import { render, staticRenderFns } from "./VideoPoup.vue?vue&type=template&id=3032596e"
import script from "./VideoPoup.vue?vue&type=script&lang=js"
export * from "./VideoPoup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports